import axios from "@/config/axiosConfig";
import { CREATE_DRAFT_CREDIT_NOTE_BILL_BASE, GET_DRAFT_CREDIT_NOTE_BILL_BASES, DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST, UPDATE_DRAFT_CREDIT_NOTE_BILL_BASE,
  DELETE_DRAFT_CREDIT_NOTE_BILL_BASE, DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS, 
  GET_DRAFT_CREDIT_NOTE_BILL_BASES_PAGE } from "../types";
import { Entry_Type } from '@/utils';

export const getDraftCreditNoteBillBasesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Debit_Account_Id,Broker_Id'
      };
      return axios.get("/draft-credit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DRAFT_CREDIT_NOTE_BILL_BASES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDraftCreditNoteBillBases = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/draft-credit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DRAFT_CREDIT_NOTE_BILL_BASES, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDraftCreditNoteBillBaseByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/draft-credit-note-bill-base/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDraftCreditNoteBillBaseById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST });
    
      return axios.get(`/draft-credit-note-bill-base/get/${id}`).then((response) => {
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createDraftCreditNoteBillBase = (draftCreditNoteBillBase) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST });
      const newDraftCreditNoteBillBase = {
        ...draftCreditNoteBillBase
      };
      return axios.post("/draft-credit-note-bill-base/add", newDraftCreditNoteBillBase,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DRAFT_CREDIT_NOTE_BILL_BASE, payload: response.data });
        } else {
          dispatch({
            type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Draft Credit Note Bill Base create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDraftCreditNoteBillBase = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.put("/draft-credit-note-bill-base/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DRAFT_CREDIT_NOTE_BILL_BASE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Draft Credit Note Bill Base update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDraftCreditNoteBillBase = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/draft-credit-note-bill-base/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DRAFT_CREDIT_NOTE_BILL_BASE, id: id });
          const include = ['id', 'Vch_No', 'Party_Note_No', 'Date', 'Account_Id', 'Debit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { draft: { draftCreditNoteBillBase: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getDraftCreditNoteBillBasesWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_CREDIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getValidatedIncrementedVchNoDraftCreditNotesBillBase = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/draft-credit-note-bill-base/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDraftCreditNotesBillBaseByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/draft-credit-note-bill-base/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};


export const getAllPurchaseBillByInvoiceNoInDraftCreditNoteBillBase = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo,
      };
      return axios.get(`/draft-credit-note-bill-base/get-all-purchase-bill-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getPaymentDetailsByDraftCreditNoteBillBaseId = (id) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        billId: id,
        billType: Entry_Type.DRAFT_CREDIT_NOTE_BILL_BASE
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-id`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};